"use client";
import { jsx as o } from "react/jsx-runtime";
import * as t from "@radix-ui/react-collapsible";
import { forwardRef as r } from "react";
const a = ({ ...l }) => /* @__PURE__ */ o(t.Root, { "data-slot": "collapsible", ...l }), n = r(({ ...l }, e) => /* @__PURE__ */ o(t.CollapsibleTrigger, { "data-slot": "collapsible-trigger", ...l, ref: e })), p = ({ ...l }) => /* @__PURE__ */ o(t.CollapsibleContent, { "data-slot": "collapsible-content", ...l });
export {
  p as CollapsibleContent,
  a as CollapsibleRoot,
  n as CollapsibleTrigger
};
